module.exports = __webpack_public_path__ + "static/bart-13133b99c17e68af3b2a664ab9a95cc5.jpg";